<script>

    export let mid;
    export let model_root;
    export let settings; // view, sort, detail_view_settings, placement_non_pinned

    function changeView(view) {
        settings.view = view;
        fetch(model_root + 'admin/menu/settings/change_view.php?mid=' + mid + '&view=' + view, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

    function changeSort(sort) {
        settings.sort = sort;
        fetch(model_root + 'admin/menu/settings/change_sort.php?mid=' + mid + '&sort=' + sort, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

    function changeDetailViewSettings(detail_view_settings) {
        settings.detail_view_settings = detail_view_settings;
        fetch(model_root + 'admin/menu/settings/change_detail_view_settings.php?mid=' + mid + '&settings=' + detail_view_settings, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

    function changePlacementNonPinned(placement_non_pinned) {
        settings.placement_non_pinned = placement_non_pinned;
        fetch(model_root + 'admin/menu/settings/change_placement_non_pinned.php?mid=' + mid + '&settings=' + placement_non_pinned, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

    function changeShowDate(show_date) {
        settings.show_date = show_date;
        fetch(model_root + 'admin/menu/settings/change_show_date.php?mid=' + mid + '&settings=' + show_date, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

    function changeShowAuthor(show_author) {
        settings.show_author = show_author;
        fetch(model_root + 'admin/menu/settings/change_show_author.php?mid=' + mid + '&settings=' + show_author, {
            method: "GET"
        })
            .then(response => { return response.text() })
            .then(msg => {
                if (msg !== "success") alert(msg);
            })
            .catch(e => alert(e));
    }

</script>

<h4 class="mb-3">Einstellungen</h4>

<div class="row mb-4">
    <h5 class="mb-3">Darstellung:</h5>
    <div class="col-5 shadow text-center pt-2 px-5 ms-3 me-3 btn"
         class:active="{settings.view === 'list'}"
         on:click={ () => { changeView("list") } }>
        <img src="/images/view_list_view.png" class="preview_image w-100 border rounded overflow-hidden d-block">
        <p class="fw-bold mt-3">Listendarstellung</p>
    </div>
    <div class="col-5 shadow text-center pt-2 px-5 btn"
         class:active="{settings.view === 'detail'}"
         on:click={ () => { changeView("detail") } }>
        <img src="/images/view_detail_view.png" class="preview_image w-100 border rounded overflow-hidden d-block">
        <p class="fw-bold mt-3">Detaildarstellung</p>
    </div>
</div>

<hr>

<h5 class="mt-3">Sortieren nach:</h5>
<small>Gepinnte Inhalte werden ungeachtet der gewählten Sortierung immer an oberster Stelle angezeigt.</small>
<br>
<div class="mt-2">
    <div class="form-check">
        <input class="form-check-input" type="radio" id="date"
               checked={settings.sort === 'date'}
               on:click={ () => { changeSort("date") } }>
        <label class="form-check-label" for="date">
            Neueste Beiträge oben
        </label>
    </div>
    <div class="form-check">
        <input class="form-check-input" type="radio" id="manually"
               checked={settings.sort === 'manually'}
               on:click={ () => { changeSort("manually") } }>
        <label class="form-check-label" for="manually">
            Manuelle Sortierung
        </label>
    </div>
</div>

{#if settings.view === 'list'}

    <hr>

    <h5 class="mt-3">Anzeige des Datums in der Listendarstellung:</h5>
    <small>(Aufgrund der Auswahl der Listendarstellung)</small>
    <br>
    <div class="mt-2">
        <div class="form-check">
            <input class="form-check-input" type="radio" id="show_date"
                   checked={settings.show_date === 'SHOW'}
                   on:click={ () => { changeShowDate("SHOW") } }>
            <label class="form-check-label" for="show_date">
                Bei den Listenelementen wird das Datum angezeigt.
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio" id="hide_date"
                   checked={settings.show_date === 'HIDE'}
                   on:click={ () => { changeShowDate("HIDE") } }>
            <label class="form-check-label" for="hide_date">
                Bei den Listenelementen wird das Datum versteckt.
            </label>
        </div>
    </div>

    <hr>

    <h5 class="mt-3">Anzeige des Autors in der Listendarstellung:</h5>
    <small>(Aufgrund der Auswahl der Listendarstellung)</small>
    <br>
    <div class="mt-2">
        <div class="form-check">
            <input class="form-check-input" type="radio" id="show_author"
                   checked={settings.show_author === 'SHOW'}
                   on:click={ () => { changeShowAuthor("SHOW") } }>
            <label class="form-check-label" for="show_author">
                Bei den Listenelementen wird der Autor angezeigt.
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio" id="hide_author"
                   checked={settings.show_author === 'HIDE'}
                   on:click={ () => { changeShowAuthor("HIDE") } }>
            <label class="form-check-label" for="hide_author">
                Bei den Listenelementen wird der Autor versteckt.
            </label>
        </div>
    </div>

{/if}

{#if settings.view === 'detail'}

    <hr>

    <h5 class="mt-3">Erweiterte Darstellungsmöglichkeiten:</h5>
    <small>(Aufgrund der Auswahl der Detaildarstellung)</small>
    <br>
    <div class="mt-2">
        <div class="form-check">
            <input class="form-check-input" type="radio" id="only_pinned"
                   checked={settings.detail_view_settings === 'only_pinned'}
                   on:click={ () => { changeDetailViewSettings("only_pinned") } }>
            <label class="form-check-label" for="only_pinned">
                Nur gepinnte Inhalte werden vollständig dargestellt, nicht gepinnte werden als Liste dargestellt.
            </label>
        </div>
        <div class="form-check">
            <input class="form-check-input" type="radio" id="all"
                   checked={settings.detail_view_settings === 'all'}
                   on:click={ () => { changeDetailViewSettings("all") } }>
            <label class="form-check-label" for="all">
                Alle Inhalte werden vollständig untereinander dargestellt.
            </label>
        </div>
    </div>

    {#if settings.detail_view_settings === 'only_pinned'}

        <hr>

        <h5 class="mt-3">Platzierung der nicht gepinnten Inhalte:</h5>
        <small>(Aufgrund der Auswahl der Erweiterten Darstellungsmöglichkeiten)</small>
        <br>
        <div class="mt-2">
            <div class="form-check">
                <input class="form-check-input" type="radio" id="below"
                       checked={settings.placement_non_pinned === 'below'}
                       on:click={ () => { changePlacementNonPinned("below") } }>
                <label class="form-check-label" for="below">
                    Unter den gepinnten Inhalten
                </label>
            </div>
            <!--<div class="form-check">
                <input class="form-check-input" type="radio" id="right"
                       checked={settings.placement_non_pinned === 'right'}
                       on:click={ () => { changePlacementNonPinned("right") } }>
                <label class="form-check-label" for="right">
                    Als Spalte rechts neben den gepinnten Inhalten (derzeit nicht funktional)
                </label>
            </div>-->
        </div>

    {/if}

{/if}

<br>



<style>
    .active {
        background-color: #52b3d9;
    }
</style>
